const API_BASE = '/api';

function getToken() { return localStorage.getItem('tipnotes_token'); }
function setToken(token) { localStorage.setItem('tipnotes_token', token); }
function clearToken() { localStorage.removeItem('tipnotes_token'); }

async function apiFetch(path, options = {}) {
  const token = getToken();
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });

  let data;
  const contentType = res.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    data = await res.json();
  } else {
    const text = await res.text();
    if (res.status === 429) throw new Error('Too many attempts. Please wait a few minutes and try again.');
    throw new Error('Server error. Please try again later.');
  }

  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

export const api = {
  // Auth
  register: (data) => apiFetch('/auth/register', { method: 'POST', body: JSON.stringify(data) }),
  login: (data) => apiFetch('/auth/login', { method: 'POST', body: JSON.stringify(data) }),
  getMe: () => apiFetch('/auth/me'),
  changePassword: (currentPassword, newPassword) => apiFetch('/auth/change-password', { method: 'POST', body: JSON.stringify({ currentPassword, newPassword }) }),
  updateMe: (data) => apiFetch('/auth/me', { method: 'PUT', body: JSON.stringify(data) }),
  verifyEmail: (token) => apiFetch(`/auth/verify-email?token=${token}`),
  resendVerification: () => apiFetch('/auth/resend-verification', { method: 'POST' }),
  forgotPassword: (email) => apiFetch('/auth/forgot-password', { method: 'POST', body: JSON.stringify({ email }) }),
  resetPassword: (token, password) => apiFetch('/auth/reset-password', { method: 'POST', body: JSON.stringify({ token, password }) }),
  checkUsername: (username) => apiFetch(`/auth/check-username/${username}`),

  // Profiles
  getProfiles: () => apiFetch('/profiles'),
  getProfile: (id) => apiFetch(`/profiles/${id}`),
  createProfile: (data) => apiFetch('/profiles', { method: 'POST', body: JSON.stringify(data) }),
  updateProfile: (id, data) => apiFetch(`/profiles/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteProfile: (id) => apiFetch(`/profiles/${id}`, { method: 'DELETE' }),
  regenerateCode: (id) => apiFetch(`/profiles/${id}/regenerate-code`, { method: 'POST' }),

  // Share (public)
  getSharedProfile: (code) => apiFetch(`/share/${code}`),
  getProfileByUsername: (username, slug) => apiFetch(`/u/${username}/${slug}`),

  // Admin
  getAdminStats: () => apiFetch('/auth/admin/stats'),
  getAdminUsers: () => apiFetch('/auth/admin/users'),
  toggleAdmin: (id) => apiFetch(`/auth/admin/users/${id}/toggle-admin`, { method: 'PUT' }),
  deleteUser: (id) => apiFetch(`/auth/admin/users/${id}`, { method: 'DELETE' }),
};

export { getToken, setToken, clearToken };
